import styled from 'styled-components';

export const JobProfileNoItems = styled.div`
  text-align: center;
  padding: 1rem;
`;

export const OppDetailTabsBlock = styled.div`
  overflow-x: hidden;
`;
